import { Injectable, type Provider } from '@angular/core';

import { EditorsPicksService } from './editors-picks.service';

/**
 * WHAT COMMS HAS CHOSEN, WITHOUT A SESSION.
 *
 * `contentFeed` is viewer-scoped, so unauthenticated the picks come back empty
 * and the wall renders with no editorial head at all — which looks like the
 * feature is not built rather than like there is no session.
 *
 * ── CHOSEN FROM THE CORPUS, ACROSS HUBS ───────────────────────────────────
 * Five posts from five different hubs, because the whole claim of the blend is
 * that comms pushes ORGANISATION-wide content into a feed the reader assembled
 * from their own hubs. Five picks from one hub would demonstrate a filter.
 *
 * Deliberately includes a post that is ALSO in the ordinary run, so the
 * de-duplication is exercised rather than assumed: without it the wall shows
 * that post twice, once flagged and once not.
 */
@Injectable()
export class EditorsPicksPreviewService extends EditorsPicksService {
  override async load(): Promise<void> {
// ⚠ LAZY, AND THE WHOLE POINT OF THIS FILE'S EXISTENCE IS WHY.
// `app.routes.ts` imports the preview PROVIDER as a value, so anything this
// module imports at the top level lands in the EAGER `main.js` — for every
// visitor, on every route, whether or not they ever open `/preview/hubs`. The
// fixture corpus is 84 kB of prototype content. Imported here, inside the one
// async method that reads it, the module registry still dedupes it across the
// preview services and nobody who is not previewing pays for any of it.
    const { HUBS_PREVIEW_ITEMS } = await import('./hubs-preview.fixtures');
    const byHub = new Map<string, (typeof HUBS_PREVIEW_ITEMS)[number]>();
    for (const item of HUBS_PREVIEW_ITEMS) {
      const hub = item.hub?._id;
      // One per hub, and only posts with something to look at — an editorial
      // head made of text tiles is a wall of headlines, not a front page.
      if (!hub || byHub.has(hub) || !item.media) continue;
      byHub.set(hub, item);
    }
    this.setPicks([...byHub.values()].slice(0, 5));
  }
}

export const EDITORS_PICKS_PREVIEW_PROVIDER: Provider = {
  provide: EditorsPicksService,
  useClass: EditorsPicksPreviewService,
};
